import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import SectionAiSettings from "@/components/SectionAiSettings";

// Sections whose AI settings live in backend section_ai_config (route /settings/ai/:section).
const SECTIONS = {
  audit_prep: {
    intro: "The AI model used by Audit Prep AI to read auditors' forms, chat about them and fill them in.",
    privacy: "This sends staff names, roles and compliance details from HR records to the model.",
  },
  incidents: {
    intro: "The AI model that writes the summary in a participant's stakeholder incident report.",
    privacy: "This sends the participant's name and incident details to the model.",
  },
  invoice_checks: {
    title: "Invoice check AI",
    intro: "The AI model that reads each shift's notes against what is about to be invoiced, and flags shifts to check before invoices are sent. It only raises warnings.",
    privacy: "This sends participant and worker names, shift notes and billing details to the model.",
  },
  shift_notes: {
    title: "Shift notes summaries",
    intro: "The AI model that summarises a participant's shift notes at the top of a shift notes PDF, and changes the summary when staff ask it to in the chat beside it.",
    privacy: "This sends the participant's name, worker names and the shift notes to the model.",
  },
};

export default function SectionAiSettingsPage() {
  const { section } = useParams();
  const meta = SECTIONS[section];
  const load = useCallback(() => api.sectionAi(section), [section]);
  const save = useCallback((m) => api.saveSectionAi(section, m), [section]);
  const test = useCallback((m) => api.testSectionAi(section, m), [section]);
  if (!meta) return <div className="p-5 text-sm text-slate-500">Unknown AI section.</div>;
  return (
    <SectionAiSettings key={section} testid={`section-ai-${section}`}
      title={meta.title || (section === "audit_prep" ? "Audit Prep AI settings" : "Incident summaries AI")}
      intro={meta.intro} privacy={meta.privacy} load={load} save={save} test={test} />
  );
}
